import { render, staticRenderFns } from "./list-disapproved.vue?vue&type=template&id=0424f867&scoped=true&"
import script from "./list-disapproved.vue?vue&type=script&lang=js&"
export * from "./list-disapproved.vue?vue&type=script&lang=js&"
import style0 from "./list-disapproved.vue?vue&type=style&index=0&id=0424f867&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0424f867",
  null
  
)

export default component.exports